const backend_url = (process.env.REACT_APP_MODE === "production") ? process.env.REACT_APP_BACKEND_PRODUCTION_URL : process.env.REACT_APP_BACKEND_DEVELOPMENT_URL;

const image_url = (process.env.REACT_APP_MODE === "production") ? process.env.REACT_APP_IMAGE_PRODUCTION_URL : process.env.REACT_APP_IMAGE_DEVELOPMENT_URL;

export const endpoints = {
    login: `${backend_url}/admin/api/admin-login`,
    logout: `${backend_url}/admin/api/logout`,
    forgotPassword: `${backend_url}/admin/api/forgot-password`,
    resetPassword: `${backend_url}/admin/api/reset-password`,
    usersCount: `${backend_url}/admin/api/users-count`,
    usersList: `${backend_url}/admin/api/users-list`,
    updateUserStatus: `${backend_url}/admin/api/edit-user-status`,
    updateUserFeature: `${backend_url}/admin/api/update-user-feature`,
    deleteUser: `${backend_url}/admin/api/remove-user`,
    profile: `${backend_url}/admin/api/profile`,
    updateProfile: `${backend_url}/admin/api/profile`,
    changePassword: `${backend_url}/admin/api/change-password`,
    notifications: `${backend_url}/admin/api/get-all-notifications`,
    contentCount: `${backend_url}/admin/api/content-count`,
    contentPosts: `${backend_url}/admin/api/get-reported-posts`,
    deleteContent: `${backend_url}/admin/api/admin-delete-post`,
    updatePostStatus: `${backend_url}/admin/api/admin-warn-or-ban-user`,
    dashboardData: `${backend_url}/admin/api/dashboard-details`,
    events: `${backend_url}/admin/api/admin-event-list`,
    eventsCount: `${backend_url}/admin/api/admin-event-count`,
    createEvent: `${backend_url}/admin/api/create-event-admin`,
    userDetail: `${backend_url}/admin/api/get-user-detail`,
    adminSendMessage: `${backend_url}/admin/api/admin-send-message`,
    deleteEvent: `${backend_url}/admin/api/admin-delete-event`,
    getSportsList: `${backend_url}/admin/api/sports-list`,
    markFeature: `${backend_url}/admin/api/admin-update-event-feature`,
    removeMedia: `${backend_url}/admin/api/admin-remove-post-media`,
    eventDetail: `${backend_url}/admin/api/admin-event-details`,
    updateEvent: `${backend_url}/admin/api/admin-update-event`,
    roles: `${backend_url}/admin/api/roles`,
    assignRole: `${backend_url}/admin/api/roles/assign`,
    systemUsers: `${backend_url}/admin/api/system-users`,
    analyticsManagement: `${backend_url}/admin/api/analytics-management`,
    settingsLogs: `${backend_url}/admin/api/settings-logs`,
    appConfigurations: `${backend_url}/admin/api/app-configurations`,
    announcements: `${backend_url}/admin/api/announcements`,
    announcementTemplates: `${backend_url}/admin/api/announcement-templates`,
    announcementPosts: `${backend_url}/admin/api/announcements-posts`,
    problemReports: `${backend_url}/admin/api/problem-reports`,
    resolveReport: `${backend_url}/admin/api/problem-reports`,
    faqs: `${backend_url}/admin/api/faqs`,
}

export { backend_url, image_url };
